<template>
  <i class="icon" :class="curClass"></i>
</template>

<script>

const iconMap = {
  battery(val) {
    if (val > 90) {
      return 'icon-a-dianliang100';
    }
    if (val > 40 && val <= 90) {
      return 'icon-a-dianliang66';
    }
    if (val > 20 && val <= 40) {
      return 'icon-a-dianliang33';
    }
    return 'icon-a-dianliang0 red';
  },

  temperature(val) {
    if (val >= 100) {
      return 'icon-a-wendu100';
    }
    if (val >= 50) {
      return 'icon-a-wendu50';
    }
    return 'icon-a-wendu20';
  }
};

export default {
  props: {
    // battery:电池 signal: 信号 wifi:WIFI  temperature:温度
    type: {
      type: String,
      default: 'battery'
    },
    value: {
      type: Number,
      default: 0
    }
  },
  computed: {
    curClass() {
      if (iconMap[this.type]) {
        return iconMap[this.type](this.value);
      }
      return '';
    }
  }
};
</script>

<style>
.red{
  color: #ED4A4A !important;
}
</style>
